import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  try {
    const token = localStorage.getItem("token") || null;

    if (!token) {
      return <Navigate to="/" replace />;
    } else {
      return children;
    }
  } catch (error) {
    return <Navigate to="/" replace />;
  }
};

export default ProtectedRoute;
